import { render } from "./C4Portal.vue?vue&type=template&id=63b78df8"
import script from "./C4Portal.vue?vue&type=script&lang=js"
export * from "./C4Portal.vue?vue&type=script&lang=js"

import "./C4Portal.vue?vue&type=style&index=0&id=63b78df8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__